import { Relationship } from './enum';

export const sortMembers = <T extends { relationshipTypeId?: Relationship; dateOfBirth?: string }>(members: T[]) => {
	return members?.sort((memberOne, memberTwo) => {
		if (memberOne.relationshipTypeId === Relationship.Self) return -1;

		if (memberTwo.relationshipTypeId === Relationship.Self) return 1;

		return new Date(memberOne.dateOfBirth!) < new Date(memberTwo.dateOfBirth!) ? -1 : 1;
	});
};
